var jobFormTypes = [
  { value: 'full-time', text: 'Full-time' },
  { value: 'part-time', text: 'Part-time' },
  { value: 'contract', text: 'Contract' },
  { value: 'internship', text: 'Internship' },
  { value: 'remote', text: 'Remote' }
]
export default jobFormTypes
